import { createContext, useContext, useState } from "react";
import { studentServices } from "../api/studentServices";
import { installmentsSummary } from "../api/installmentsSummary";
import { paymentHistory } from "../api/paymentHistory";
import { activeRoute } from "../api/activeRoute";
import { announcementServices } from "../api/announcementServices";

const DataContext = createContext();

export function DataProvider({ children }) {
  const [studentData, setStudentData] = useState(null);
  const [activeRouteData, setActiveRouteData] = useState(null);
  const [paymentHistoryData, setPaymentHistoryData] = useState(null);
  const [installmentsSummaryData, setInstallmentsSummaryData] = useState(null);
  const [announcementsData, setAnnouncementsData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getAnnouncementsData = async (forceRefresh = false) => {
    if (!forceRefresh && announcementsData) return;

    setLoading(true);
    try {
      const res = await announcementServices.getAll();
      const data = res?.data;
      setAnnouncementsData(Array.isArray(data?.data) ? data.data : data);
    } catch (error) {
      console.error("Duyurular yüklenirken hata:", error);
    } finally {
      setLoading(false);
    }
  };

  const getAllData = async (forceRefresh = false) => {
    const token = localStorage.getItem("token");
    if (!token) {
      getAnnouncementsData(forceRefresh);
      return;
    }

    if (
      !forceRefresh &&
      studentData &&
      activeRouteData &&
      paymentHistoryData &&
      installmentsSummaryData &&
      announcementsData
    ) {
      return;
    }

    setLoading(true);
    try {
      const results = await Promise.allSettled([
        studentServices.getByToken(),
        installmentsSummary.getByToken(),
        paymentHistory.getByToken(),
        activeRoute.getByToken(),
        announcementServices.getAll(),
      ]);

      if (results[0].status === "fulfilled")
        setStudentData(results[0].value?.data?.data);
      if (results[1].status === "fulfilled")
        setInstallmentsSummaryData(results[1].value?.data?.data);
      if (results[2].status === "fulfilled")
        setPaymentHistoryData(results[2].value?.data?.data);
      if (results[3].status === "fulfilled")
        setActiveRouteData(results[3].value?.data?.data);
      if (results[4].status === "fulfilled") {
        const annRes = results[4].value?.data;
        setAnnouncementsData(
          Array.isArray(annRes?.data) ? annRes.data : annRes,
        );
      }
    } catch (error) {
      console.error("Veriler yüklenirken hata oluştu:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DataContext.Provider
      value={{
        studentData,
        activeRouteData,
        paymentHistoryData,
        installmentsSummaryData,
        announcementsData,
        loading,
        getAllData,
        getAnnouncementsData,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  return useContext(DataContext);
}
